export interface FrameInfo {
  readonly panelID: string;
  readonly frameID: string;
  readonly reference: [string, string]; // [opf, cfi]
  readonly shouldNotifyContentSize: boolean;
  readonly shouldApplyReflowableContentSettings: boolean;
}

export interface ArkWindow extends Window {
  // Injected by viewer
  ARK_FRAME_INFO: FrameInfo;
}

export const ArkFrameInfo = (window as ArkWindow).ARK_FRAME_INFO;

export function isArkWindow(window: Window): window is ArkWindow {
  return 'ARK_FRAME_INFO' in window;
}
